var React = require('react');

function SDownload18 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.4,10H10V1.25A.25.25,0,0,0,9.75,1H8.25A.25.25,0,0,0,8,1.25V10H5.6a.25.25,0,0,0-.177.427l3.40022,3.39622a.25.25,0,0,0,.35346-.0001L12.573,10.427A.25.25,0,0,0,12.4,10Z","fill":"var(--iconFill, #6e6e6e)","key":0}),React.createElement("path",{"d":"M15,13.25V15H3V13.25A.25.25,0,0,0,2.75,13H1.25a.25.25,0,0,0-.25.25V16.5a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5V13.25a.25.25,0,0,0-.25-.25h-1.5A.25.25,0,0,0,15,13.25Z","fill":"var(--iconFill, #6e6e6e)","key":1})]);
}

SDownload18.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDownload18;

SDownload18.default = SDownload18;
